import type { AxiosRequestConfig } from 'axios'
import type {
  Schedule,
  ScheduleDay,
  StrapiScheduleData,
  StrapiScheduleResponse,
} from './types'
import { getRequest } from '../http'

// Function to format time from "HH:mm:ss" to "HH:mm"
function formatTime(time: string): string {
  return time.substring(0, 5) // Remove seconds
}

// Function to map Strapi response to frontend format
function mapStrapiScheduleToSchedule(strapiData?: StrapiScheduleData): Schedule {
  // Define all days of the week in Spanish
  const allDays = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']

  // Group shifts by day name
  const dayGroups: { [key: string]: string[] } = {}

  // Initialize all days with empty arrays
  allDays.forEach((day) => {
    dayGroups[day] = []
  })

  // Fill with actual data from Strapi
  strapiData?.days.forEach((day) => {
    if (!dayGroups[day.day]) {
      dayGroups[day.day] = []
    }

    day.shifts.forEach((shift) => {
      const formattedShift = `${formatTime(shift.start)} - ${formatTime(shift.end)}`
      dayGroups[day?.day]?.push(formattedShift)
    })
  })

  // Convert to ScheduleDay array in the correct order
  const days: ScheduleDay[] = allDays.map((dayName) => {
    return {
      days: dayName,
      shifts: Array.isArray(dayGroups[dayName]) && dayGroups[dayName].length > 0 ? dayGroups[dayName] : ['Cerrado'],
    }
  })

  return {
    id: strapiData?.documentId || '',
    days: days || [''],
  }
}

// API function to get schedule from Strapi
export async function getSchedule(axiosConfig?: AxiosRequestConfig): Promise<Schedule> {
  const response = await getRequest<StrapiScheduleResponse>(
    '/horarios?populate[days][populate]=shifts',
    axiosConfig,
  )

  if (!response.data.data || response.data.data.length === 0) {
    throw new Error('No schedule data found')
  }

  // Return the first schedule (assuming there's only one)
  return mapStrapiScheduleToSchedule(response.data.data[0])
}
